var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"pageName"}},[_c('p',{staticClass:"pageName"},[_c('span',[_vm._v("Step"+_vm._s(_vm.step))]),_vm._v(_vm._s(_vm.pageTitle[_vm.step-1]))])])
}
var staticRenderFns = []

export { render, staticRenderFns }